import React from "react";
import Applet from "../../Applet";
import ETLJobExecutionTable from "../../../../components/ETLJob/ETLJobExecutionTable";

class ETLJobExecutionTableApplet extends Applet {

    constructor(props) {
        super(props);

        if (props.enterpriseComponent.getEnterpriseObject() !== null) {
            this.state.Placement.xl.splice(1,1)
        }
    }
    render() {
        return <ETLJobExecutionTable applet={this}
                                       pageSize={this.state.PageSize}
                                       placement={this.state.Placement}
                                       columns={this.state.Columns}
                                       title="Job Executions"
                                       enterpriseComponent={this.getEnterpriseComponent()}
                                       sort={this.state.Sort}
                                       menu={this.state.Menu}
                                       rowHeight={this.state.RowHeight}
        />;
    }

    state = {
        Name: "ETLJobExecutionTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "New Execution",
                    value: "New Execution",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 40,
            "xs": 3,
            "sm": 3,
            "md": 40,
            "lg": 40,
            "lx": 40,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "ETLJobName",
                },
                {
                    id: "Status",
                },
                {
                    id: "StatusReason",
                },
                {
                    id: "CreatedDatetime",
                },
                {
                    id: "StartedDatetime",
                },
                {
                    id: "StoppedDatetime",
                },
                {
                    id: "Difference",
                },
                {
                    id: "Actions",
                },
            ]
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "ETLJobName",
                width: 250,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Job Name",
            },
            {
                id: "Status",
                width: 150,
                cellRenderer: "Status Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Status",
            },
            {
                id: "StatusReason",
                width: 350,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Status Reason",
            },
            {
                id: "CreatedDatetime",
                width: 220,
                cellRenderer: "Local Datetime Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Created at",
            },
            {
                id: "StartedDatetime",
                width: 220,
                cellRenderer: "Local Datetime Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Started at",
            },
            {
                id: "StoppedDatetime",
                width: 220,
                cellRenderer: "Local Datetime Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Stopped at",
            },
            {
                id: "Difference",
                width: 200,
                cellRenderer: "Difference Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Total run time",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
        ],
    };
}

export default ETLJobExecutionTableApplet;
